import Vue from 'vue'
import Vuex from 'vuex'

//参考链接 https://blog.csdn.net/qq_32674347/article/details/105807542
// import SecureLS from "secure-ls";
// var ls = new SecureLS({
//   encodingType: "aes",
//   isCompression: false,
//   encryptionSecret: "ad879037-c7a4-4063-9236-6bfc35d54b7d"
// });





import mineStore from './mineStore'
// wyk持久化 one
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

// 加入secure-ls前配置
export default new Vuex.Store({
  modules: {
    mineStore
  },
  plugins: [createPersistedState()] // wyk持久化 two
})

// export default new Vuex.Store({
//   modules: {
//     mineStore
//   },
//   plugins: [createPersistedState(
//     {
//       key: "encrypteddata",
//       storage: {
//         getItem: key => ls.get(key),
//         setItem: (key, value) => ls.set(key, value),
//         removeItem: key => ls.remove(key)
//       }
//     }
//   )] // wyk持久化 two
// })



// WEBPACK FOOTER //
// ./src/store/index.js